import styled from 'styled-components';
import { Icon } from '@trustedshops/tps-seo-shared-frontend-react-components';

export const RelevancyExplanationModalOpener = styled(Icon)`
  cursor: pointer;
`;
